import * as React from "react";
import type { SVGProps } from "react";
const SvgWechartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.247 8.253c.276 0 .548.02.818.05C16.33 4.916 12.67 2.4 8.495 2.4 3.825 2.4 0 5.55 0 9.549c0 2.308 1.273 4.204 3.4 5.674l-.85 2.529 2.969-1.474c1.063.208 1.915.422 2.976.422.266 0 .53-.013.792-.034a6.191 6.191 0 0 1-.262-1.76c0-3.673 3.187-6.653 7.222-6.653Zm-4.567-2.28c.64 0 1.063.418 1.063 1.05 0 .63-.423 1.052-1.063 1.052-.637 0-1.275-.422-1.275-1.052 0-.632.638-1.05 1.275-1.05ZM5.735 8.076c-.637 0-1.28-.422-1.28-1.052 0-.632.643-1.05 1.28-1.05s1.06.418 1.06 1.05c0 .63-.423 1.052-1.06 1.052ZM24 14.805c0-3.361-3.398-6.1-7.215-6.1-4.042 0-7.225 2.739-7.225 6.1 0 3.365 3.183 6.099 7.225 6.099.845 0 1.699-.21 2.548-.421l2.33 1.262-.639-2.1C22.73 18.379 24 16.7 24 14.805Zm-9.558-1.053c-.423 0-.85-.416-.85-.84 0-.42.427-.84.85-.84.643 0 1.063.42 1.063.84 0 .424-.42.84-1.063.84Zm4.672 0c-.42 0-.843-.416-.843-.84 0-.42.424-.84.843-.84.637 0 1.063.42 1.063.84 0 .424-.426.84-1.063.84Z"
    />
  </svg>
);
export default SvgWechartIcon;
